import React from 'react';
import styled, {css} from 'styled-components';
import babel from './bagel_yellow.svg';


const SwitcherWrap = styled.div`
  display: flex;
  align-items: center;
`;

const SwitcherLabel = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: ${props => props.active ? '#141204' : '#C4C4C4'};
  cursor: pointer;
`;

const SwitcherHandler = styled.div`
  width: 95px;
  height: 44px;
  background-color: #F1F1F1;
  border-radius: 20px;
  padding: 7px 10px;
  position: relative;
  margin: 0 20px;
  cursor: pointer;

  &:before{
    content: url(${babel});
    position: absolute;
    top: 1px;
    left: 5px;
    display: block;
    width: 40px;
    height: 40px;
    transition: all 0.4s;
  }

  ${({switched}) => switched && css`
    &:before {
      transform: translateX(45px) rotate(90deg);
    }
  `}
`;


const Switcher = ({controls, switchedControl, onChange}) => {
  return (
    <SwitcherWrap>
      <SwitcherLabel onClick={() => onChange(controls[0])}
                     active={switchedControl.val === controls[0].val}>
        {controls[0].title}
      </SwitcherLabel>

      <SwitcherHandler switched={switchedControl.val === controls[1].val}
                       onClick={() => onChange(switchedControl.val === controls[0].val ? controls[1] : controls[0])}/>

      <SwitcherLabel onClick={() => onChange(controls[1])}
                     active={switchedControl.val === controls[1].val}>
        {controls[1].title}
      </SwitcherLabel>
    </SwitcherWrap>
  )
}

export default Switcher
